import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstant } from '@app/core/constant/app-constant';
import { Settings } from '@app/core/services/settings.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss'],
})
export class DeviceComponent implements OnInit, AfterViewInit {
  returnUrl: string | null;

  year: number = new Date().getFullYear();
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly settingsService: Settings,
    private readonly toaster: ToastrService
  ) {
    this.returnUrl = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.settingsService.getFeatureSettings().subscribe({
      next: (res) => {
        if (!res.data.settings.isMobileWebAppDownloadViewEnabled) {
          this.onclick();
        }
      },
      error: (error) => {
        if (error.status !== AppConstant.PORT.Forbidden)
          this.toaster.error(error?.error?.message ?? error.message);
      },
    });
  }

  ngAfterViewInit(): void {
  }

  onclick() {
    let d: Date = new Date();
    d.setTime(d.getTime() + 14 * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    document.cookie = `kGlnOFjvPy=1; ${expires}`;
    this.router.navigate(['/']);
  }
}
